import type { IDedicatedException } from "@gettactic/api";
import { format, isValid, parseISO } from "date-fns";

/** "Sep 21" from a `yyyy-MM-dd` day; an empty or malformed day stays as it is. */
export const formatDay = (day: string): string => {
  const parsed = parseISO(`${day}T00:00:00`);
  return isValid(parsed) ? format(parsed, "MMM d") : day;
};

/** "Sep 21 – Sep 25", or "Sep 21" for a single day. */
export const formatReleaseSpan = (startsOn: string, endsOn: string): string =>
  startsOn === endsOn
    ? formatDay(startsOn)
    : `${formatDay(startsOn)} – ${formatDay(endsOn)}`;

/** "Anyone", or the teams and people a release names. */
export const describeRelease = (exception: IDedicatedException): string => {
  if (exception.release === "open") {
    return "Anyone";
  }
  const names = [...exception.teams, ...exception.users].map((x) => x.name);
  return names.length > 0 ? names.join(", ") : "Nobody named";
};

/**
 * The releases still ahead on `today` (`yyyy-MM-dd`), the ones running now
 * included, earliest first. Past releases are history the map need not show.
 */
export const upcomingReleases = (
  releases: readonly IDedicatedException[],
  today: string
): IDedicatedException[] =>
  releases
    .filter((release) => release.ends_on >= today)
    .sort((a, b) => a.starts_on.localeCompare(b.starts_on));
